import { ProductGroupNameEnum, TabNameEnum } from "@interfaces/enums/tabName.enum";

export interface ITrackingItems {
  item_name: string;
  item_variant: string;
  item_list_name: TabNameEnum;
  item_list_id: ProductGroupNameEnum;
  price?: number;
  quantity?: number;
  time?: string;
}

export enum MetaEventTypeEnum {
  standart = "track",
  custom = "trackCustom",
}

export interface IMetaTrackEventData {
  value: number;
  contents: ITrackingItems[];
  num_items?: number;
  currency?: string;
}
